import { SpinnerCircular } from "spinners-react";
import styled, { css } from "styled-components";
import theme from "../../styles/colors";
import { Bold, Subhead } from "../../styles/typography";
import Button from "../Button";

const DialogBody = styled.div`
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  box-sizing: border-box;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DialogTitle = styled(Bold)`
  color: rgb(${(props) => props.theme.colors.neutral600});
`;

const DialogSubtitle = styled(Subhead)`
  color: rgb(${(props) => props.theme.colors.neutral200});
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FlatButton = css`
  border: none;
  @media (hover: hover) {
    &:hover:not(:disabled) {
      border: none;
    }
  }
`;

const BlockButton = styled(Button)`
  width: 100%;
  box-sizing: border-box;
  ${(props) => {
    if (props.$flat) {
      return FlatButton;
    }
  }}
`;

const SavingRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 4px;
`;

export default function SaveChangesModal({
  onSave,
  onDiscard,
  onCancel,
  isSaving,
}) {
  if (isSaving) {
    return (
      <DialogBody>
        <SavingRow>
          <SpinnerCircular
            size={20}
            thickness={200}
            speed={100}
            color={`rgba(${theme.colors.neutral600}, 1)`}
            secondaryColor={`rgba(${theme.colors.neutral150}, 1)`}
          />
          <DialogTitle as="p">Saving changes</DialogTitle>
        </SavingRow>
      </DialogBody>
    );
  }

  return (
    <DialogBody>
      <TextBlock>
        <DialogTitle as="p">Save changes?</DialogTitle>
        <DialogSubtitle as="p">
          You have unsaved changes on this chapter.
        </DialogSubtitle>
      </TextBlock>
      <Actions>
        <BlockButton variant="primary" onButtonClick={onSave}>
          Save &amp; leave
        </BlockButton>
        <BlockButton variant="warning" onButtonClick={onDiscard}>
          Discard changes
        </BlockButton>
        <BlockButton $flat={true} variant="tertiary" onButtonClick={onCancel}>
          Keep editing
        </BlockButton>
      </Actions>
    </DialogBody>
  );
}
